<template>
    <div id="assignments" class="mb-5 container page">
        <div class="row">
            <div class="col-md-12 mb-3">
                <h2>Actuele Opdrachten</h2>
                <div class="text-center" v-if="isLoading">
                    <loader width="5rem"></loader>
                </div>
                <div class="text-center vert-center" v-else-if="activeAssignments.length == 0">
                    <h5 class="mx-auto text-muted">U heeft momenteel geen lopende opdrachten.</h5>
                </div>
                <div class="list-group" v-else>
                    <div class="list-group-item list-group-item-action flex-column align-items-start" v-for="a in activeAssignments" :key="a.id">
                        <div class="d-flex w-100 justify-content-between">
                            <h4 class="mb-1">{{a.city}} | {{a.title}}</h4>
                            <small class="invisible-sm">Publicatiedatum: {{new Date(a.publicationDate).toLocaleDateString()}}</small>
                        </div>
                        <div class="d-flex w-100 justify-content-between">
                            <div class="invisible-sm">
                                <p class="mb-1">{{a.description}}</p>                                
                                <p class="mb-1">Datums: <span class="badge badge-secondary mr-1" v-for="d in a.dates" :key="d.id">{{new Date(d.date).toLocaleDateString()}} ({{d.hours}} uur)</span></p>
                            </div>   
                            <div>                         
                                <router-link tag="button" class="btn btn-outline-azure" :to="{ name: 'ClientAssignment', params: { 'id': a.id } }">Opdracht Bekijken</router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
            </div>
            <div class="col-md-12 mb-3">
                <h2>Openstaande Opdrachten</h2>
                <div class="text-center" v-if="isLoading">
                    <loader width="5rem"></loader>
                </div>
                <div class="text-center vert-center" v-else-if="openAssignments.length == 0">
                    <h5 class="mx-auto text-muted">U heeft geen openstaande opdrachten.</h5>
                </div>
                <div class="list-group">
                    <div class="list-group-item list-group-item-action flex-column align-items-start" v-for="a in openAssignments" :key="a.id">
                        <div class="d-flex w-100 justify-content-between">
                            <h4 class="mb-1">{{a.city}} | {{a.title}}</h4>
                            <small class="invisible-sm">Publicatiedatum: {{new Date(a.publicationDate).toLocaleDateString()}}</small>
                        </div>
                        <div class="d-flex w-100 justify-content-between">
                            <div class="invisible-sm">
                                <p class="mb-1">{{a.description}}</p>
                                <p class="mb-1">Datums: <span class="badge badge-secondary mr-1" v-for="d in a.dates" :key="d.id">{{new Date(d.date).toLocaleDateString()}}</span></p>
                            </div>     
                            <div>                       
                                <router-link tag="button" class="btn btn-outline-azure mr-3 mb-1" :to="{ name: 'ClientAssignment', params: { 'id': a.id } }">Opdracht Bekijken</router-link>
                                <button class="btn btn-danger" type="button" @click="revoke(a)">Opdracht Annuleren</button>                       
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
            </div>
            <div class="col-md-12 mb-3">
                <h2>Laatste 5 Afgeronde <span class="invisible-sm"> / Verlopen </span>Opdrachten</h2>
                <div class="text-center" v-if="isLoading">
                    <loader width="5rem"></loader>
                </div>
                <div class="text-center vert-center" v-else-if="completedAssignments.length == 0">
                    <h5 class="mx-auto text-muted">U heeft nog geen opdrachten voltooid.</h5>
                </div>
                <div class="list-group">
                    <div class="list-group-item list-group-item-action flex-column align-items-start" v-for="a in completedAssignments" :key="a.id">
                        <div class="d-flex w-100 justify-content-between">
                            <h4 class="mb-1">{{a.city}} | {{a.title}}</h4>
                            <small class="invisible-sm">Publicatiedatum: {{new Date(a.publicationDate).toLocaleDateString()}}</small>
                        </div>
                        <div class="d-flex w-100 justify-content-between">
                            <div class="invisible-sm">
                                <p class="mb-1">{{a.description}}</p>
                                <p class="mb-1">Datums: <span class="badge badge-secondary mr-1" v-for="d in a.dates" :key="d.id">{{new Date(d.date).toLocaleDateString()}}</span></p>
                            </div>   
                            <div>                           
                                <router-link tag="button" class="btn btn-outline-azure" :to="{ name: 'ClientAssignment', params: { 'id': a.id } }">Opdracht Bekijken</router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
            </div>
            <div class="col-md-12 mb-3">
                <h2>Laatste 5 Geweigerde Opdrachten</h2>
                <div class="text-center" v-if="isLoading">
                    <loader width="5rem"></loader>
                </div>
                <div class="text-center vert-center" v-else-if="declinedAssignments.length == 0">
                    <h5 class="mx-auto text-muted">U heeft nog geen opdrachten voltooid.</h5>
                </div>
                <div class="list-group">
                    <div class="list-group-item list-group-item-action flex-column align-items-start" v-for="a in declinedAssignments" :key="a.id">
                        <div class="d-flex w-100 justify-content-between">
                            <h4 class="mb-1">{{a.city}} | {{a.title}}</h4>
                            <small class="invisible-sm">Publicatiedatum: {{new Date(a.publicationDate).toLocaleDateString()}}</small>
                        </div>
                        <div class="d-flex w-100 justify-content-between">
                            <div class="invisible-sm">
                                <p class="mb-1">{{a.description}}</p>
                                <p class="mb-1">Datums: <span class="badge badge-secondary mr-1" v-for="d in a.dates" :key="d.id">{{new Date(d.date).toLocaleDateString()}}</span></p>
                            </div>  
                            <div>                            
                                <router-link tag="button" class="btn btn-outline-azure" :to="{ name: 'ClientAssignment', params: { 'id': a.id } }">Opdracht Bekijken</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loader from '@/components/Loader';
export default {
    components: {
        Loader,
    },
    data() {
        return {
            isLoading: false,
            openAssignments: [],
            activeAssignments: [],
            completedAssignments: [],
            declinedAssignments: []
        }
    },
    mounted() {
        this.getOpenAssignments();
        this.getActiveAssignments();
        this.getCompletedAssignments();
        this.getDeclinedAssignments();
    },
    methods:
    {
        revoke(assignment)
        {
            this.$http.post('api/Assignments/Revoke/' + assignment.id).then(() => {
                this.openAssignments.splice(this.openAssignments.indexOf(assignment), 1);
            });
        },
        getOpenAssignments() {
            this.isLoading = true;
            this.$http.get("api/Assignments/Client/Open?take=9999").then((res) => {
                this.openAssignments = res.data;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },
        getActiveAssignments() {
            this.isLoading = true;
            this.$http.get("api/Assignments/Client/Active?take=9999").then((res) => {
                this.activeAssignments = res.data;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },
        getCompletedAssignments() {
            this.isLoading = true;
            this.$http.get("api/Assignments/Client/Completed?take=5").then((res) => {
                this.completedAssignments = res.data;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },
        getDeclinedAssignments() {
            this.isLoading = true;
            this.$http.get("api/Assignments/Client/Declined?take=5").then((res) => {
                this.declinedAssignments = res.data;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        }
    }
}
</script>

<style scoped>
</style>